export const styles = () => ({
  tableCell: {
    width: '100%'
  }
})



// WEBPACK FOOTER //
// ./src/components/Drivers/styles.js